import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the notification function
   */
  fetchNotification: (): Promise<any> => {
    return getRequest(`${config.notificationApiUrl}api/facility/v1/general-log/notifications`);
  },
  /**
   * Fetch the notification function
   */
  fetchNotificationCount: (): Promise<any> => {
    return getRequest(
      `${config.notificationApiUrl}api/facility/v1/general-log/getNotificationCount`,
    );
  },
  /**
   * Fetch the notification function
   */
  updateNotificationAsRead: (data: any): Promise<any> => {
    return postRequest(
      `${config.notificationApiUrl}api/facility/v1/general-log/markNotificationsRead/`,
      data,
    );
  },
  /**
   * Fetch the alerts data function
   * @param query
   * @returns
   */
  fetchAlerts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.notificationApiUrl}api/facility/v1/general-log/alerts`, {
      ...parameters,
    });
  },
};
